import { CloseOutlined } from "@ant-design/icons";
import { Dialog, DialogContent } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import useAirlineAdminApi from "../../services/api/useAirlineAdminApi";
import "../css/SearchAircraftDialog.css";
import Loader from "../../components/element/Loader";

const SearchAircraftDialog = ({ open, onClose, onSelectAircraft }) => {
  const [searchText, setSearchText] = useState("");
  const [searchedAircraft, setSearchedAircraft] = useState([]);
  const { fetchListOfAircraft, searchAircraft } = useAirlineAdminApi();

  const { data: aircraftListData, isLoading } = useQuery({
    queryKey: ["get-all-aircraft-list"],
    queryFn: fetchListOfAircraft,
    retry: false,
  });

  const searchAircraftMutation = useMutation({
    mutationFn: ({ data }) =>
      searchAircraft({
        icaoCode: data,
      }),
    onSuccess: (response) => {
      setSearchedAircraft(sortedAircraftList(response?.data));
    },
  });

  useEffect(() => {
    setSearchedAircraft(sortedAircraftList(aircraftListData?.data));
  }, [aircraftListData]);

  const sortedAircraftList = (aircraftList) => {
    const sortedAircraft = aircraftList?.sort((a, b) => {
      const nameA = a?.icaoCode.toLowerCase();
      const nameB = b?.icaoCode.toLowerCase();
      return nameA.localeCompare(nameB);
    });
    return sortedAircraft;
  };

  const handleAircraftSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
    if (text.length > 0) {
      searchAircraftMutation.mutate({
        data: text,
      });
    } else {
      setSearchedAircraft(sortedAircraftList(aircraftListData?.data));
    }
  };

  const handleSelectAircraft = (aircraft) => {
    onSelectAircraft(aircraft);
    onClose();
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "search-aircraft-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="search-aircraft-dialog-close"
          onClick={onClose}
        />
        <div className="search-aircraft-dialog-content">
          <div className="search-aircraft-dialog-title">Search Aircraft</div>
          <input
            placeholder="Search Aircraft"
            value={searchText}
            onChange={handleAircraftSearchChange}
            maxLength={30}
          ></input>
          <div className="search-aircraft-dialog-list">
            {searchAircraftMutation?.isPending || isLoading ? (
              <Loader />
            ) : searchedAircraft?.length > 0 ? (
              searchedAircraft?.map((aircraft) => (
                <div
                  key={aircraft?.id}
                  className="search-aircraft-dialog-list-item"
                  onClick={() => handleSelectAircraft(aircraft)}
                >
                  {aircraft?.icaoCode}
                </div>
              ))
            ) : (
              <div className="search-aircraft-dialog-no-results">
                No results found
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SearchAircraftDialog;
